import { LocaleEnum } from '@/locale/types';

export const checkDefinedLocaleLang = (locale: string) => {
  return Object.values<string>(LocaleEnum).includes(locale)
    ? (locale as LocaleEnum)
    : LocaleEnum.Ko;
};
